var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"loading":_vm.loading}},[_c('mixed-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"fetch-data":_vm.getDataForTable,"reload-table":_vm.reloadTable,"tbProps":_vm.tableProps}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }